/**
 * Roughly how wide one bold glyph is, as a fraction of the font size. Kept on
 * the generous side so an estimate errs toward a smaller, fitting wordmark.
 */
const GLYPH_WIDTH_EM = 0.62;

/**
 * The font size (in SVG user units) for a replica's name drawn as `<text>` in
 * place of a wordmark drawing: `base` for a short name, shrunk so a long
 * one still fits in `maxWidth` instead of running past the artwork.
 */
export function wordmarkFontSize(
  name: string,
  base: number,
  maxWidth: number
): number {
  return Math.min(base, maxWidth / (name.length * GLYPH_WIDTH_EM));
}
